module.exports = __webpack_public_path__ + "img/auto1.59ce1bce.png";